import API from './settings'

export const closedTicketsTTR = (project_code: string, formData: any): any => {
    return API.post(`${project_code}/reports/closed_tickets/ttr_avg`, formData);
};

export const closedTicketsAmount = (project_code: string, formData: any): any => {
    return API.post(`${project_code}/reports/closed_tickets/amount`, formData);
};

export const closedTicketsTable = (project_code: string, formData: any): any => {
    return API.post(`${project_code}/reports/closed_tickets/tables`, formData);
};

export const aggDateRangeCountFilter = (project_code: string, formData: {}): any => {
    return API.post(`${project_code}/ticket_close/daterange_count`, formData);
}
